<template>
  <div @click="goToHomepage" class="regular_link">
    <VcImage class="logo" :image="isBranded ? branding.logo_path : branding.new_logo_path"/>
  </div>
</template>

<script>
import {postMessageService} from "@/modules/common/services";

export default {
  name: "GoToHomepage",
  props: {
    isBranded: {
      type: Boolean,
      default: false
    },
    branding: {
      type: Object
    }
  },
  methods:{
    goToHomepage: function() {
      postMessageService.post('go_to_homepage')
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.logo {
  height: 34px !important;
  min-height: 34px;

  @include md-and-up{
    height: 41px !important;
    margin-top: 5%;
    cursor:pointer;
  }
}

.regular_link {
  display:flex;
}

</style>
